import Icon from '@components/Icon';
import type {ReactElement} from 'react';
import {localize} from '@services/i18n';

interface Props {
    likeUrl: string;
    iconName: string;
    className: string;
}

export default function Like(props: Props): ReactElement<Props> {
    function handleLike() {
        window.open(props.likeUrl, localize('Likes_shareLabel'), 'width=500,height=300');
    }

    return (
        <div className={`likes__like ${props.className}`} onClick={handleLike}>
            <Icon name={props.iconName} className="likes__icon svgicon_24" />
        </div>
    );
}
